import http from "@/utils/request";

const PermissionApi = {
  listRolePermission(data) {
    return http.sendRequest({
      METHOD_NAME: "permission.listRolePermission",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
  listUserPermission(data) {
    return http.sendRequest({
      METHOD_NAME: "permission.listUserPermission",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
};
export default PermissionApi;
